export default {
  common: {
    siteTitle: "墓志铭 - 萝北来信的作品集",
    siteDescription: "希望每个人都可以找到自己的理想并为之劳动。萝北来信的作品集、游戏、小说与画作。（曾用名 tobenot）",
    nav: {
      home: "首页",
      about: "墓志铭",
      blog: "博客（思想集）",
      experience: "体验指南",
      paintings: "绘画",
      photographs: "摄影",
      sounds: "留声",
      celebration: "庆典"
    },
    search: {
      placeholder: "搜索作品（标题、描述、标签…）",
      noResults: "没有找到匹配的作品",
      resultsTitle: "搜索结果"
    },
    footer: {
      quote: "感谢你来看我的世界观，我的小说，我的动漫，我的游戏",
      copyright: "保留所有权利"
    },
    actions: {
      back: "返回作品集",
      backToTop: "回到顶部",
      viewProject: "访问项目",
      click: "点击访问",
      explore: "点击探索",
      promoBadge: "宣发",
      prev: "上一张",
      next: "下一张"
    },
    sort: {
      title: "排序方式",
      byPride: "按本人喜好度",
      byDate: "按时间",
      date: ""
    },
    pagination: {
      page: "还有呢！"
    },
    filter: {
      portfolioKind: "作品类型",
      portfolioKinds: {
        complete: "完成度高",
        study: "习作",
        ongoing: "进行中"
      },
      byTechnology: "技术栈",
      activeTag: "当前筛选",
      activeCategory: "分类",
      clearTags: "清除标签筛选",
      clearAll: "清除全部"
    }
  },
  home: {
    subtitle: "希望每个人都可以找到自己的理想并为之劳动",
    intro: "欢迎来到我的作品体验指南。因为涉猎广泛，这里我为您准备了不同领域的传送门。请根据您的兴趣，选择最适合的体验路线。",
    conclusion: "感谢您花时间体验我的作品。无论您选择了哪条路线，都希望这段旅程能让您感受到我的创作理念。如果您有任何想法或反馈，欢迎随时与我分享。"
  },
  about: {
    title: "墓志铭",
    subtitle: "数字时代的永恒印记",
    sectionTitle: "痕迹画廊 (数字遗产)",
    signature: "—— 萝北来信（曾用名 tobenot）",
    status: {
      private: "私密保留",
      archived: "已归档",
      public: "公开可见"
    }
  },
  project: {
    aboutWork: "关于此作品",
    tags: "标签",
    promoCta: "了解更多 · 宣发页",
    filterByTag: "查看包含 {tag} 的作品",
    category: {
      all: "全部",
      vrchat: "VRChat 创作",
      novel: "小说与世界观",
      ai: "AI原生游戏",
      game: "独立游戏",
      tool: "工具与实验",
      video: "视频/播客",
      blog: "认识作者"
    },
    categoryDesc: {
      all: "浏览全部作品，按兴趣自行探索。",
      vrchat: "我在 VRChat 中构建的社交、阅读与实验性空间。",
      novel: "沉下心来，阅读我构建的文字宇宙与故事。",
      ai: "融合大语言模型与游戏机制的互动体验。",
      game: "传统独立游戏，包括动作射击等。",
      tool: "体验我为解决实际需求而开发的实用网页工具。",
      video: "通过视频和播客的形式，分享我的创作过程和思考。",
      blog: "如果你想了解我是谁、我怎么思考、以及我留下了什么痕迹。"
    },
    metadata: {
      date: "日期",
      engine: "引擎",
      platform: "平台",
      scale: "体量",
      roles: "参与角色",
      status: "状态",
      kind: "类型",
      experienceable: "体验入口"
    },
    developerNotes: "开发者手记",
    achievements: "里程碑与数据",
    series: "同系列作品",
    seriesCurrent: "当前",
    celebrationLink: "参展于 {title}",
    backToCelebration: "返回 {title}",
    statusBadge: {
      experienceable: "可体验"
    },
    experienceable: {
      yes: "可体验",
      no: "暂不可体验"
    },
    portfolioKind: {
      study: "习作"
    },
    status: {
      released: "已发布",
      development: "开发中",
      halted: "停工",
      archived: "已归档",
      concept: "草稿",
      private: "私密",
      // 保留旧版兼容
      playable: "可玩",
      unplayable: "不可玩",
      video: "视频",
      tool: "工具",
      reading: "阅读"
    }
  },
  experience: {
    title: "体验指南",
    subtitle: "多维度的创作切片，选择属于你的体验路线",
    feedback: "反馈与联系"
  },
  gallery: {
    title: "画廊",
    description: "这里收录了我的绘画作品和摄影作品，记录生活中的美好瞬间",
    noGallery: "暂无画廊作品",
    notFound: "未找到该作品"
  },
  paintings: {
    title: "绘画",
    description: "这里展示我的绘画创作，记录心灵的色彩",
    noPaintings: "暂无绘画作品",
    backToList: "返回绘画"
  },
  photographs: {
    title: "摄影",
    description: "通过镜头捕捉的瞬间，定格时光与光影",
    noPhotographs: "暂无摄影作品",
    backToList: "返回摄影"
  },
  sounds: {
    title: "留声",
    description: "这里是我的声音创作空间，记录音乐与声音的点滴",
    backToList: "返回留声",
    listen: "进入收听",
    play: "播放",
    pause: "暂停",
    lyrics: "歌词",
    noLyrics: "（无歌词）",
    noSounds: "暂无音频作品"
  },
  celebration: {
    notFound: "未找到该届庆典。",
    missingBooth: "摊位作品「{slug}」尚未配置或不存在。"
  }
} 